import React from "react";
import { Box, Button, Typography, Modal, Stack } from "@mui/material";
import PropTypes from "prop-types";

const Subuserben = ({ open, onClose, title }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="popup-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "rgba(0, 0, 0, 0.6)", // Semi-transparent black
          backdropFilter: "blur(10px)", // Frosted glass effect
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.37)", // Shadow for depth
          p: 4,
          borderRadius: 2,
          maxWidth: 400,
          width: "100%",
          color: "white", // Make text color white for contrast
        }}
      >
        <Typography
          id="popup-title"
          variant="h6"
          component="h2"
          gutterBottom
          sx={{ color: "#ffee20", textAlign: "center" }}
        >
          {title || "Subscriber Benefits"}
        </Typography>

        <Stack spacing={1} sx={{ mt: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" component="span" sx={{ marginRight: "8px" }}>
              🎵
            </Typography>
            <Typography variant="body1" component="span">
              Pre-release music to subscribers only
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" component="span" sx={{ marginRight: "8px" }}>
              🔒
            </Typography>
            <Typography variant="body1" component="span">
              Private livestreams for subscribers only
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" component="span" sx={{ marginRight: "8px" }}>
              🏅
            </Typography>
            <Typography variant="body1" component="span">
              Special badge for subscribers only
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography variant="body1" component="span" sx={{ marginRight: "8px" }}>
              📺
            </Typography>
            <Typography variant="body1" component="span">
              VOD livestreams for subscribers only
            </Typography>
          </Box>
        </Stack>

        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{ mt: 3, width: "100%" }}
        >
          Got It!
        </Button>
      </Box>
    </Modal>
  );
};

// Add prop types
Subuserben.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default Subuserben;

